// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgramItemSubHeader_diet_container__1Prw-"};